export enum NameCurrentWebApi{
    ProcessStart,
    FetchFromGit,
    StopIISSite,
    FolderClear,
    PublishToDirectory,
    StartIISSite
}